import { yupResolver } from '@hookform/resolvers/yup';
import { Box, TextField } from '@mui/material';
import { isEmpty } from 'lodash-es';
import { useEffect } from 'react';
import { useForm, FormProvider, FieldValues } from 'react-hook-form';
import {
  WsTypography,
  WsTypoColors,
  WsTypoVariants,
  useWsEditor,
  WsButton,
  WsEditor,
  WsColors,
} from 'wisestep-base';
import * as yup from 'yup';

interface IEmailPreview {
  emailBody: string;
  emailSubject: string;
  isLoaded: boolean;
  onProceed: (body?: string) => void;
  setEmailBody: (body: string) => void;
}

interface EmailFormInputs {
  subject: string;
  body: string;
}

const emailFormSchema = yup.object({
  subject: yup.string().nullable(),
  body: yup.string().nullable(),
});

const fieldWrapperStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

const EmailPreview = ({
  emailBody,
  emailSubject,
  isLoaded,
  onProceed,
  setEmailBody,
}: IEmailPreview) => {
  const methods = useForm<EmailFormInputs>({
    defaultValues: {
      subject: '',
      body: '',
    },
    resolver: yupResolver(emailFormSchema),
  });

  const { setValue, handleSubmit } = methods;
  const editor = useWsEditor(
    '',

    (htmlBody) => {
      setValue('body', htmlBody ?? '');
    }
  );

  useEffect(() => {
    if (!isLoaded || !editor || editor.isDestroyed) return;

    !isEmpty(emailSubject) && setValue('subject', emailSubject);

    if (!isEmpty(emailBody)) {
      setValue('body', emailBody);
      editor.commands.setContent(emailBody);
    }
  }, [emailBody, emailSubject, isLoaded, setValue, editor]);

  const onSubmit = (data: FieldValues) => {
    setEmailBody(data?.body ?? '');
    onProceed(data?.body ?? '');
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box display="flex" flexDirection="column" gap={3} mt={3}>
          <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.BLACK} bold>
            Preview or make changes to email
          </WsTypography>
          <Box sx={fieldWrapperStyle}>
            <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.GREYTEXT}>
              Subject
            </WsTypography>
            <TextField fullWidth disabled {...methods.register('subject')} />
          </Box>
          <Box sx={fieldWrapperStyle}>
            <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.GREYTEXT}>
              Body
            </WsTypography>
            <Box
              sx={{
                maxHeight: 300,
                overflowY: 'auto',
                border: `1px solid ${WsColors.ToolbarColor}`,
                borderRadius: 1,
                p: 1,
              }}
            >
              <WsEditor key="body" editor={editor} isLoaded={isLoaded} />
            </Box>
          </Box>
          <Box display="flex" justifyContent="flex-end">
            <WsButton variant="contained" type="submit">
              Save & Proceed
            </WsButton>
          </Box>
        </Box>
      </form>
    </FormProvider>
  );
};

export default EmailPreview;
